import * as Icons from 'lucide-react';
import { industries } from '../mock';

export default function Industries() {
  return (
    <section className="py-24 bg-fx-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Industries</p>
            <h2 className="font-display text-4xl lg:text-5xl text-fx-navy font-bold mt-3 leading-tight">Financing across every sector</h2>
            <div className="fx-section-divider mt-5" />
            <p className="text-slate-700 mt-6 leading-relaxed">
              We work with vendors and owners across the Canadian economy. From a single piece of equipment to comprehensive vendor programs, our team understands the assets and the cashflows behind them.
            </p>
          </div>
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-4">
            {industries.map((ind, i) => {
              const Icon = Icons[ind.icon] || Icons.Sparkles;
              return (
                <div key={i} className="group bg-white rounded-md border border-slate-200 p-5 fx-lift">
                  <div className="w-10 h-10 rounded-md bg-fx-navy text-fx-gold flex items-center justify-center group-hover:bg-fx-gold group-hover:text-fx-navy transition-colors">
                    <Icon className="w-5 h-5" />
                  </div>
                  <p className="font-semibold text-fx-navy mt-4">{ind.name}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
